import React from 'react';

function ProgramLinkImporterModal({setShowProgramLinkImporterModalFlag, programLinkImporterInputData, setProgramLinkImporterInputData, startProgramImportViaLinks}) {
    function closeModal(){
        setShowProgramLinkImporterModalFlag(false);
    }

    return (
        <div className="modal" style={{display: "flex"}}>
            <div className="modal-content-centered">
                <span onClick={closeModal} className="close">&times;</span>
                <div className="modal-section">
                    <a style={{fontSize: "21px", fontWeight: "500"}}>Paste entire program links:</a>
                    <textarea cols="77" rows="14" style={{marginTop: "20px", marginBottom: "20px"}} value={programLinkImporterInputData} onChange={e => setProgramLinkImporterInputData(e.target.value)} />
                    <button className="normal-button-system" onClick={startProgramImportViaLinks} style={{width: "160px", margin: "auto", marginBottom: "12px"}}>Start Import</button>
                </div>
            </div>
        </div>
    );
}

export default ProgramLinkImporterModal;